import api from 'src/utils/api/core'

export function getTideStations(portUuid) {
  return api.get(`/tide_stations?portUuid=${portUuid}`)
}
